import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const NotificationIcon = ({ color = '#000', size = 24, ...props }) => (
  <svg
    height={size}
    viewBox="0 0 25 28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5 28c1.933 0 3.5-1.343 3.5-3H9c0 1.657 1.568 3 3.5 3zm12.02-7.97c-1.079-1.147-3.096-2.874-3.096-8.53 0-4.296-3.04-7.735-7.14-8.579V1.77C14.285.792 13.487 0 12.5 0c-.985 0-1.785.792-1.785 1.77V2.92c-4.099.844-7.139 4.283-7.139 8.579 0 5.656-2.017 7.383-3.095 8.53A1.719 1.719 0 0 0 0 21.23C.006 22.139.724 23 1.791 23H23.21A1.779 1.779 0 0 0 25 21.23a1.718 1.718 0 0 0-.48-1.2z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

NotificationIcon.propTypes = propTypes;

export default NotificationIcon;
